import {
  step_styles_default
} from "./chunk.UR7LZ7P4.js";
import {
  l
} from "./chunk.SUTDMD3F.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  watch
} from "./chunk.WGQU6RP3.js";
import {
  HasSlotController
} from "./chunk.CLKP6Z3C.js";
import {
  hasTag
} from "./chunk.UFU6LZT7.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  i,
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/stepper/step.ts
var FadvStep = class extends s {
  constructor() {
    super(...arguments);
    this.hasSlotController = new HasSlotController(this, "step-label");
    this.orientation = "horizontal";
    this.labelMode = "label";
  }
  handleVisitedChanged() {
    if (!this.spacer)
      return;
    this.spacer.indicate = this.active || this.visited;
    emit(this, "step-visited-change");
  }
  handleActiveChange() {
    emit(this, "step-active-change");
  }
  activate(previousStepIndex) {
    this.active = true;
    this.activeInternal = true;
    if (previousStepIndex < this.index && this.spacer) {
      this.spacer.indicate = true;
    } else {
      this.visited = false;
    }
    emit(this, "step-activation-complete");
  }
  deactivate(currentStepIndex) {
    this.active = false;
    this.activeInternal = false;
    this.visited = currentStepIndex > this.index;
    if (this.spacer) {
      this.spacer.indicate = this.visited;
    }
  }
  async connectedCallback() {
    super.connectedCallback();
    await this.updateComplete;
    if (hasTag(this.previousElementSibling, "fadv-step")) {
      this.spacer = document.createElement("fadv-step-spacer");
      this.spacer.indicate = this.active || this.visited;
      this.insertAdjacentElement("beforebegin", this.spacer);
    } else if (this.spacer) {
      this.spacer.remove();
      this.spacer = void 0;
    }
  }
  handleStepClick() {
    const stepper = this.parentElement;
    if (!this.linear && this.index > stepper.selectedStep) {
      this.activeInternal = true;
    }
    emit(this, "step-activated", { detail: { index: this.index } });
  }
  focus(options) {
    var _a;
    (_a = this.step) == null ? void 0 : _a.focus(options);
  }
  blur() {
    this.step.blur();
  }
  getAriaDisabled() {
    if (!this.linear)
      return "false";
    return this.visited || this.active ? "false" : "true";
  }
  renderIndicatorInterior() {
    return $`<div class="step__indicator"><div class="step__outline"></div><div class="step__indicator-interior"><slot>${this.index + 1}</slot></div></div>`;
  }
  renderLabelElement() {
    return $`<label part="step-label" id="label"><slot name="step-label">${this.label}</slot></label>`;
  }
  renderIndicator(hasLabel) {
    if (this.labelMode === "tooltip" && hasLabel) {
      return $`<fadv-tooltip hoist variant=${this.visited || this.active ? "primary" : "default"} placement=${this.orientation === "horizontal" ? "top" : "right"} >${this.renderIndicatorInterior()}<div slot="content">${this.renderLabelElement()}</slot></fadv-tooltip>`;
    }
    if (this.labelMode === "label" && hasLabel) {
      return $` ${this.renderIndicatorInterior()}<div class="step__label">${this.renderLabelElement()}</div>`;
    }
    return this.renderIndicatorInterior();
  }
  getRoles() {
    if (this.mode === "progress")
      return "listitem";
    return "tab";
  }
  render() {
    const hasLabel = !!this.label || this.hasSlotController.test("step-label");
    return $`<div role=${this.getRoles()} aria-posinset=${this.index + 1} aria-setsize=${this.setSize} aria-labelledby=${l(hasLabel ? "label" : void 0)} aria-selected=${this.active ? "true" : "false"} aria-disabled=${this.getAriaDisabled()} tabindex=${this.active ? "0" : "-1"} class=${o({
      step: true,
      "step--active": !!this.activeInternal,
      "step--visited": !!this.visited,
      "step--vertical": this.orientation === "vertical",
      "step--horizontal": this.orientation === "horizontal",
      "step--linear": this.linear,
      "step--vertical-label": this.orientation === "vertical" && this.labelMode === "label" && hasLabel
    })} @click=${this.handleStepClick} >${this.renderIndicator(hasLabel)}</div>`;
  }
};
FadvStep.styles = step_styles_default;
__decorateClass([
  e()
], FadvStep.prototype, "label", 2);
__decorateClass([
  e()
], FadvStep.prototype, "panel", 2);
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvStep.prototype, "active", 2);
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvStep.prototype, "visited", 2);
__decorateClass([
  e()
], FadvStep.prototype, "mode", 2);
__decorateClass([
  e()
], FadvStep.prototype, "orientation", 2);
__decorateClass([
  e()
], FadvStep.prototype, "linear", 2);
__decorateClass([
  e()
], FadvStep.prototype, "index", 2);
__decorateClass([
  e()
], FadvStep.prototype, "setSize", 2);
__decorateClass([
  e()
], FadvStep.prototype, "labelMode", 2);
__decorateClass([
  i(".step")
], FadvStep.prototype, "step", 2);
__decorateClass([
  i(".step__indicator")
], FadvStep.prototype, "indicator", 2);
__decorateClass([
  t()
], FadvStep.prototype, "activeInternal", 2);
__decorateClass([
  watch("visited")
], FadvStep.prototype, "handleVisitedChanged", 1);
__decorateClass([
  watch("active")
], FadvStep.prototype, "handleActiveChange", 1);
FadvStep = __decorateClass([
  n("fadv-step")
], FadvStep);

export {
  FadvStep
};
